import { API, Auth } from 'aws-amplify';
import { findUsersByGovernmentId } from "../graphql/queries";
import { updateUser } from "../graphql/mutations";
import { APP_AUTH_MODE } from '../constants/app';
import { NUM_ITEMS_PER_PAGE } from '../constants/table';
import { deleteUser } from '../features/user/userActions';

const listUsersInGroups = async (governmentId, groups = [], nextToken = null, minItems = 2 * NUM_ITEMS_PER_PAGE) => {
  try {
    const items = [];
    const variables = {
      governmentId: governmentId,
      filter: {
        and: [
          {isDeleted: {ne: true}},
          {email: {attributeExists: true}},
          {username: {attributeExists: true}}
        ]
      }
    };
    if (groups.length) {
      const groupFilter = {or: []};
      for (const group of groups) {
        groupFilter.or.push({
          groups: {contains: group}
        })
      }
      variables.filter.and.push(groupFilter);
    }
    // eslint-disable-next-line no-constant-condition
    while (true) {
      variables.nextToken = nextToken;
      const data = await API.graphql({
        query: findUsersByGovernmentId,
        variables,
        authMode: APP_AUTH_MODE
      });
      nextToken = data.data.findUsersByGovernmentId.nextToken;
      items.push(...data.data.findUsersByGovernmentId.items.filter(user => user?.isDeleted !== true));
      if (!nextToken) break;
      if (items.length>=minItems) break;
    }
    const uniqueItems = items.filter((user, index, self) =>
      user?.id && self.findIndex(item => item?.id === user.id) === index
    );
    return {
      success: true,
      data: uniqueItems,
      nextToken
    }
  }
  catch (e) {
    return {
      success: false,
      error: e
    }
  }
}

const fetchUserData = async () => {
  try {
    await Auth.currentAuthenticatedUser();
  } catch (error) {
    console.error("Error fetching user data:", error);
  }
};


export const handleDeleteUser = async (id, dispatch, getUsers, onDeleteSuccess) => {
  const result = confirm("Are you sure to delete this user?");
  if (result === true) {
    try {
      const { data } = await API.graphql({
        query: updateUser,
        variables: {
          input: {
            id,
            isDeleted: true,
          },
        },
        authMode: APP_AUTH_MODE,
      });

      if (data?.updateUser) {
        const cognitoDeleteResult = await dispatch(deleteUser(data?.updateUser?.username));
        if (cognitoDeleteResult.error) {
          console.error("Error when deleting user:", cognitoDeleteResult.payload);
          await API.graphql({
            query: updateUser,
            variables: {
              input: {
                id,
                isDeleted: false,
              },
            },
            authMode: APP_AUTH_MODE,
          });
          await getUsers();
          return;
        }
        if (onDeleteSuccess) {
          onDeleteSuccess(id);
        }
        await getUsers();
        fetchUserData(data?.updateUser?.username);
      } else {
        console.error("Error when deleting user:", data?.message);
      }
    } catch (error) {
      console.error("Error when deleting user:", error);
    }
  }
};

export {
  listUsersInGroups
}
